<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات دستور پخت"
        >
          <b-form
              ref="foodrecipesform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2 form-size"
                  md="6"
                  offset-md="3"
              >
                <b-row>

                  <b-col
                      class="image"
                      cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                            ref="previewEl"
                            :src="Form.Image"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                          :ref="'refInputEl'"
                          type="file"
                          class="d-none"
                          name="Image"
                          @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                              label="عنوان"
                              label-for="Title"
                              class="mb-0"
                          >
                            <b-form-input
                                id="Title"
                                v-model="Form.Title"
                                name="Title"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                      </b-row>

                    </b-media>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="غذا"
                        label-for="FoodId"
                    >
                      <z-food
                          v-model="Form.FoodId"
                          :multiple="false"
                          :clearable="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="وضعیت"
                        label-for="Visibility"
                    >
                      <v-select
                          v-model="Form.Status"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          :clearable="false"
                          :options="enums('Status')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                    <b-col cols="12">
                      <b-row class="mt-1">

                        <b-col md="8">
                          <b-form-group
                              label="توضیحات"
                          />
                        </b-col>

                        <b-col md="2">
                          <b-form-group
                              label="عکس"
                          />
                        </b-col>

                      </b-row>

                      <draggable
                          v-model="Form.FoodRecipesDetails"
                          class="list-group list-group-flush cursor-move"
                      >
                        <b-row
                            v-for="(item, index) in Form.FoodRecipesDetails"
                            :id="item"
                            :key="index"
                            ref="FoodRecipesDetails"
                            class="mb-1"
                        >

                          <b-col
                              md="8"
                              class="foodrecipes"
                          >
                            <b-form-group>
                              <feather-icon
                                  class="mr-1"
                                  icon="MoreVerticalIcon"
                                  size="16"
                              />
                              <b-form-textarea
                                  v-model="item.Description"
                                  name="Description"
                                  rows="3"
                                  no-resize
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="2">
                            <b-media class="mb-2">
                              <template #aside>
                                <b-avatar
                                    ref="previewEl"
                                    :src="item.Image"
                                    size="90px"
                                    rounded
                                    badge-left
                                    badge-top
                                    button
                                    class="foodrecipes-image"
                                    @click="$refs['refInputEl'+index][0].click()"
                                >
                                  <template
                                      v-if="item.Image"
                                      #badge
                                  >
                                    <feather-icon
                                        button
                                        icon="XIcon"
                                        size="24"
                                        @click="removeImage($event, item)"
                                    />
                                  </template>
                                </b-avatar>
                              </template>
                              <input
                                  :ref="'refInputEl'+index"
                                  type="file"
                                  class="d-none"
                                  @input="imageRenderer($event, index)"
                              >
                            </b-media>
                          </b-col>

                          <b-col
                              md="2"
                              class="mb-1"
                              style="display: flex; align-items: center;"
                          >
                            <div v-if="foodRecipesDetailsRemoveId !== index">
                              <b-button
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-danger"
                                  class="btn-icon rounded-circle"
                                  @click="removeFoodRecipesDetails(index)"
                              >
                                <feather-icon
                                    icon="TrashIcon"
                                />
                              </b-button>
                            </div>
                            <div v-else>
                              <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle"
                                  variant="outline-primary"
                                  @click="cancelFoodRecipesDetails"
                              >
                                <feather-icon icon="XIcon" />
                              </b-button>
                              <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle ml-1"
                                  variant="outline-primary"
                                  @click="confirmFoodRecipesDetails"
                              >
                                <feather-icon icon="CheckIcon" />
                              </b-button>
                            </div>
                          </b-col>
                        </b-row>
                      </draggable>

                    </b-col>

                    <b-col>
                      <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          class="mb-1"
                          variant="gradient-info"
                          @click="addFoodRecipesDetails"
                      >
                        <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                        />
                        <span>افزودن</span>
                      </b-button>
                    </b-col>

                    <b-col cols="12">
                      <hr>
                    </b-col>
                    <b-col cols="12">
                      <b-row class="mt-1">

                        <b-col md="4">
                          <b-form-group
                              label="مواد لازم"
                          />
                        </b-col>

                        <b-col md="6">
                          <b-form-group
                              label="میزان مصرف"
                          />
                        </b-col>

                      </b-row>

                      <b-row
                          v-for="(item, index) in Form.FoodRecipesIngredient"
                          :id="item"
                          :key="index"
                          ref="FoodRecipesIngredient"
                          class="mb-1"
                      >

                        <b-col md="4">
                          <b-form-group>
                            <z-food
                                v-model="item.FoodId"
                                :unselectable="Form.FoodRecipesIngredient.map(x => x.FoodId)"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="6">
                          <b-form-group>
                            <b-form-input
                                v-model="item.Consumption"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col
                            md="2"
                            class="mb-1"
                            style="display: flex; align-items: flex-end;"
                        >
                          <div v-if="foodRecipesIngredientRemoveId !== index">
                            <b-button
                                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger"
                                class="btn-icon rounded-circle"
                                @click="removeFoodRecipesIngredient(index)"
                            >
                              <feather-icon
                                  icon="TrashIcon"
                              />
                            </b-button>
                          </div>
                          <div v-else>
                            <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle"
                                variant="outline-primary"
                                @click="cancelFoodRecipesIngredient"
                            >
                              <feather-icon icon="XIcon" />
                            </b-button>
                            <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                class="btn-icon rounded-circle ml-1"
                                variant="outline-primary"
                                @click="confirmFoodRecipesIngredient"
                            >
                              <feather-icon icon="CheckIcon" />
                            </b-button>
                          </div>
                        </b-col>
                      </b-row>

                    </b-col>

                    <b-col>
                      <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="gradient-info"
                          class="mb-1"
                          @click="addFoodRecipesIngredient"
                      >
                        <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                        />
                        <span>افزودن</span>
                      </b-button>
                    </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZFood from '@/tools/food.vue'
import draggable from 'vuedraggable'
import {ref} from "@vue/composition-api/dist/vue-composition-api";
import {useInputImageRenderer} from "@core/comp-functions/forms/form-utils";

export default {
  name: 'BlogDetails',
  components: {
    draggable,
    ZFood,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Status: 1,
        FoodId: null,
        FoodRecipesDetails: [],
        FoodRecipesIngredient: [],
      },
      loading: false,
      foodRecipesIngredientRemoveId: null,
      foodRecipesDetailsRemoveId: null,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.foodrecipes.add
      if (this.$route.params.id) {
        url = this.$api.foodrecipes.update
      }

      const formData = new FormData(this.$refs.foodrecipesform)

        formData.append('Id', this.Form.Id)

      if (this.Form.FoodId != null){
        formData.append('FoodId',  this.Form.FoodId  )
      }

      if (this.Form.Status != null){
        formData.append('Status', this.Form.Status)
      }


      this.Form.FoodRecipesDetails.forEach((item, index) => {
        if (typeof (item.Id) === 'number') {
          formData.append(`FoodRecipesDetails[${index}].Id`, item.Id)
        }
        if (item.RemoveImage !== undefined) {
          formData.append(`FoodRecipesDetails[${index}].RemoveImage`, item.RemoveImage)
        }
        formData.append(`FoodRecipesDetails[${index}].Image`, item.ImageFile)
        formData.append(`FoodRecipesDetails[${index}].Description`, item.Description)
        formData.append(`FoodRecipesDetails[${index}].Sort`, index)
      })

      this.Form.FoodRecipesIngredient.forEach((item, index) => {
        if (typeof (item.FoodId) === 'number') {
          formData.append(`FoodRecipesIngredient[${index}].FoodId`, item.FoodId)
          formData.append(`FoodRecipesIngredient[${index}].Consumption`, item.Consumption)
        }
      })

      this.loading = true
      this.$http.post(
          url, formData,
      )
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event, index = null) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      if (index !== null){
        fileReader.onload = () => {
          this.Form.FoodRecipesDetails[index].Image = fileReader.result
          this.Form.FoodRecipesDetails[index].ImageFile = event.target.files[0]
        }
      }else{
        fileReader.onload = () => {
          this.Form.Image = fileReader.result
        }
      }
    },
    removeImage(event, item) {
      this.$set(item, 'RemoveImage', true)
      this.$set(item, 'Image', null)
      event.stopPropagation()
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.foodrecipes.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
          })
    },
    addFoodRecipesDetails() {
      this.Form.FoodRecipesDetails.push({
        Id: null,
        Description: null,
        Sort: 0,
        Image: null,
        RemoveImage: false,
      })
    },
    removeFoodRecipesDetails(index) {
      this.foodRecipesDetailsRemoveId = index
    },
    cancelFoodRecipesDetails() {
      this.foodRecipesDetailsRemoveId = null
    },
    confirmFoodRecipesDetails() {
      this.Form.FoodRecipesDetails.splice(this.foodRecipesDetailsRemoveId, 1)
      this.foodRecipesDetailsRemoveId = null
    },
    addFoodRecipesIngredient() {
      this.Form.FoodRecipesIngredient.push({
        FoodId: null,
        Consumption: null,
      })
    },
    removeFoodRecipesIngredient(index) {
      this.foodRecipesIngredientRemoveId = index
    },
    cancelFoodRecipesIngredient() {
      this.foodRecipesIngredientRemoveId = null
    },
    confirmFoodRecipesIngredient() {
      this.Form.FoodRecipesIngredient.splice(this.foodRecipesIngredientRemoveId, 1)
      this.foodRecipesIngredientRemoveId = null
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
